document.addEventListener('DOMContentLoaded', function () {
  if (window.arcosGiftExperienceInit) return;
  window.arcosGiftExperienceInit = true;

  var dataNode = document.querySelector('[data-arcos-gift-popup-data]');
  var modal = document.getElementById('ArcosGiftJourneyModal');

  if (!dataNode || !modal) return;

  var body = modal.querySelector('[data-arcos-gift-modal-body]');
  var closeButton = modal.querySelector('[data-arcos-gift-close]');

  var STORAGE_PREFIX = 'arcosGiftJourneyV3';
  var PREV_ELIGIBLE_KEY = STORAGE_PREFIX + ':prevEligible';
  var SHOWN_FIRST_KEY = STORAGE_PREFIX + ':shownFirst';
  var CONFIRMED_GIFT_SIG_KEY = STORAGE_PREFIX + ':confirmedGiftSignature';
  var LAST_VIEWED_GIFT_SIG_KEY = STORAGE_PREFIX + ':lastViewedGiftSignature';

  var runtime = {
    busy: false,
    config: null,
    lastGiftSignature: '',
    initialisedCartSnapshot: false,
    evalTimer: null,
    catalogPromise: null
  };

  try {
    runtime.config = JSON.parse(dataNode.textContent);
  } catch (error) {
    console.error('[Arcos Gift Experience] No se pudo leer la configuración JSON', error);
    return;
  }

if (!runtime.config || !Array.isArray(runtime.config.tiers) || !runtime.config.tiers.length) {
  return;
}

var DEFAULT_UI = {
  close: 'Cerrar',
  emptyStateText: 'No se han podido cargar los regalos en este momento.',
  viewGiftPage: 'Ver página de regalos',
  badgeSoldOut: 'Agotado',
  badgeUnlocked: 'Desbloqueado',
  badgeRemaining: 'Te faltan [[amount]]',
  metaUnlockWith: 'Desbloquea con [[amount]] en productos sin descuento.',
  lockTextUnlocked: 'Ya puedes elegir este regalo.',
  lockTextRemaining: 'Te quedan [[amount]] en productos sin descuento.',
  imageStatusAvailableFrom: 'Disponible desde [[amount]]',
  buttonSoldOut: 'Agotado',
  buttonChooseGift: 'Elegir regalo',
  buttonLocked: 'Aún no disponible',
  carouselPrev: 'Ver regalos anteriores',
  carouselNext: 'Ver más regalos',
  helperNextTier: 'Siguiente meta: [[goal]]. Te faltan [[remaining]] en productos sin descuento para desbloquear más regalos.',
  helperMaxReached: 'Ya has llegado a la meta máxima y tienes todos los regalos desbloqueados.',
  eyebrowUnlocked: 'Regalo desbloqueado',
  titleFirstUnlock: '¡Ya puedes elegir tu regalo!',
  textFirstUnlock: 'Has alcanzado los [[amount]] en productos <strong>sin descuento</strong>. Aquí puedes ver todos los regalos de la promo: los ya desbloqueados se pueden elegir ahora y los demás aparecen en gris hasta alcanzar su meta.',
  buttonLater: 'Más tarde',
  confirmationTextNextTier: 'Tu regalo ya se ha añadido correctamente. Recuerda que, si llegas a la siguiente meta de [[amount]] en productos sin descuento, desbloquearás nuevos regalos y podrás cambiar tu elección por uno de los nuevos.',
  confirmationTextMax: 'Tu regalo ya se ha añadido correctamente. Ya estás en la última meta de la promo y no quedan más regalos por desbloquear.',
  eyebrowAdded: 'Regalo añadido',
  titleAdded: '¡Ya se ha añadido tu regalo!',
  buttonGoGiftPage: 'Ir a la página de regalos',
  errorEyebrow: 'Ups',
  errorTitle: 'No he podido añadir el regalo',
  errorText: 'Ha ocurrido un problema al intentar añadir el regalo. Inténtalo otra vez o elígelo desde la página de regalos.'
};

function uiText(key, replacements) {
  var text = '';
  if (runtime.config && runtime.config.ui && runtime.config.ui[key] != null) {
    text = String(runtime.config.ui[key]);
  } else if (DEFAULT_UI[key] != null) {
    text = String(DEFAULT_UI[key]);
  }

  if (!text || !replacements || typeof replacements !== 'object') {
    return text;
  }

  return text.replace(/\[\[(\w+)\]\]/g, function (match, token) {
    return replacements[token] != null ? String(replacements[token]) : '';
  });
}

runtime.config.tiers = runtime.config.tiers
    .slice()
    .sort(function (a, b) {
      return (a.amountCents || 0) - (b.amountCents || 0);
    })
    .map(function (tier) {
      return Object.assign({}, tier, {
        productHandles: Array.isArray(tier.productHandles) ? tier.productHandles : [],
        products: Array.isArray(tier.products) ? tier.products : []
      });
    });

  function normalizePath(path) {
    var value = String(path || '/').split('?')[0].split('#')[0];
    if (value.length > 1) value = value.replace(/\/+$/, '');
    return value || '/';
  }

  function isGiftPage() {
    return normalizePath(window.location.pathname) === normalizePath(runtime.config.giftPageUrl);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isCampaignActive() {
    var start = new Date(runtime.config.campaign.start).getTime();
    var end = new Date(runtime.config.campaign.end).getTime();
    var now = Date.now();
    return now >= start && now <= end;
  }

  function isPromoGift(item) {
    return !!(
      item &&
      item.properties &&
      (
        item.properties._agp_promo_role === 'gift' ||
        item.properties._promo_role === 'gift' ||
        item.properties._kite_promo_role === 'gift'
      )
    );
  }

  function itemHasDiscount(item) {
    if (!item) return false;

    if (typeof item.total_discount === 'number' && item.total_discount > 0) return true;
    if (typeof item.line_level_total_discount === 'number' && item.line_level_total_discount > 0) return true;

    if (
      typeof item.final_line_price === 'number' &&
      typeof item.original_line_price === 'number' &&
      item.final_line_price < item.original_line_price
    ) {
      return true;
    }

    if (
      typeof item.final_price === 'number' &&
      typeof item.original_price === 'number' &&
      item.final_price < item.original_price
    ) {
      return true;
    }

    return false;
  }

  function getLinePriceCents(item) {
    if (!item) return 0;

    if (typeof item.original_line_price === 'number') return item.original_line_price;
    if (typeof item.final_line_price === 'number') return item.final_line_price;
    if (typeof item.line_price === 'number') return item.line_price;

    var unitPrice = 0;

    if (typeof item.original_price === 'number') {
      unitPrice = item.original_price;
    } else if (typeof item.final_price === 'number') {
      unitPrice = item.final_price;
    } else if (typeof item.price === 'number') {
      unitPrice = item.price;
    }

    return unitPrice * (item.quantity || 1);
  }

  function getCurrentTierIndex(totalCents) {
    var index = -1;

    runtime.config.tiers.forEach(function (tier, tierIndex) {
      if (totalCents >= (tier.amountCents || 0)) {
        index = tierIndex;
      }
    });

    return index;
  }

  function getCartSummary(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var eligibleTotal = 0;
    var promoGifts = [];

    items.forEach(function (item) {
      if (isPromoGift(item)) {
        promoGifts.push(item);
        return;
      }

      if (itemHasDiscount(item)) return;

      eligibleTotal += getLinePriceCents(item);
    });

    var currentTierIndex = getCurrentTierIndex(eligibleTotal);
    var currentTier = currentTierIndex >= 0 ? runtime.config.tiers[currentTierIndex] : null;
    var nextTier = currentTierIndex + 1 < runtime.config.tiers.length
      ? runtime.config.tiers[currentTierIndex + 1]
      : null;

    var currentGift = promoGifts.length ? promoGifts[0] : null;
    var giftSignature = promoGifts
      .map(function (item) {
        return [
          item.key || '',
          item.product_id || '',
          item.properties && item.properties._agp_goal_id ? item.properties._agp_goal_id : ''
        ].join(':');
      })
      .join('|');

    return {
      cart: cart,
      items: items,
      eligibleTotal: eligibleTotal,
      promoGifts: promoGifts,
      hasGift: promoGifts.length > 0,
      currentGift: currentGift,
      giftSignature: giftSignature,
      currentTierIndex: currentTierIndex,
      currentTier: currentTier,
      nextTier: nextTier
    };
  }

  function formatMoney(cents) {
    var locale = document.documentElement.lang || 'es-ES';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format((cents || 0) / 100);
    } catch (error) {
      return ((cents || 0) / 100).toFixed(2) + ' €';
    }
  }

  async function fetchProductByHandle(handle) {
    if (!handle) return null;

    var response = await fetch('/products/' + encodeURIComponent(handle) + '.js?_=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      console.warn('[Arcos Gift Experience] No se pudo cargar el producto', handle);
      return null;
    }

    var product = await response.json();
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var selectedVariant = variants.find(function (variant) {
      return variant && variant.available;
    }) || variants[0];

    if (!selectedVariant) {
      console.warn('[Arcos Gift Experience] Producto sin variantes válidas', handle);
      return null;
    }

    return {
      productId: product.id,
      handle: product.handle,
      title: product.title,
      url: '/products/' + product.handle,
      image: product.featured_image || '',
      variantId: selectedVariant.id,
      available: !!selectedVariant.available
    };
  }

  async function ensureCatalogLoaded() {
    if (runtime.catalogPromise) {
      return runtime.catalogPromise;
    }

    runtime.catalogPromise = (async function () {
      for (var tierIndex = 0; tierIndex < runtime.config.tiers.length; tierIndex += 1) {
        var tier = runtime.config.tiers[tierIndex];
        var existingProducts = Array.isArray(tier.products) ? tier.products.slice() : [];
        var seenHandles = Object.create(null);

        existingProducts.forEach(function (product) {
          if (product && product.handle) {
            seenHandles[String(product.handle)] = true;
          }
        });

        var handles = Array.isArray(tier.productHandles) ? tier.productHandles : [];

        for (var handleIndex = 0; handleIndex < handles.length; handleIndex += 1) {
          var handle = handles[handleIndex];
          if (!handle || seenHandles[handle]) continue;

          var fetchedProduct = await fetchProductByHandle(handle);
          if (fetchedProduct) {
            existingProducts.push(fetchedProduct);
            seenHandles[handle] = true;
          }
        }

        tier.products = existingProducts;
      }

      return runtime.config.tiers;
    })().catch(function (error) {
      runtime.catalogPromise = null;
      throw error;
    });

    return runtime.catalogPromise;
  }

  function openModal() {
    if (isGiftPage()) return;
    modal.hidden = false;
    document.body.classList.add('arcos-gift-experience-open');
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('arcos-gift-experience-open');
    runtime.busy = false;
  }

  function queueEvaluateGiftFlow(delay) {
    if (runtime.evalTimer) {
      window.clearTimeout(runtime.evalTimer);
    }

    runtime.evalTimer = window.setTimeout(function () {
      evaluateGiftFlow();
    }, delay || 350);
  }

  function buildProgress(summary) {
    var total = summary.eligibleTotal || 0;
    var max = runtime.config.tiers[runtime.config.tiers.length - 1].amountCents || 1;
    var width = Math.max(0, Math.min((total / max) * 100, 100));
    var markers = runtime.config.tiers.map(function (tier, index) {
      var classes = ['arcos-gift-experience__marker'];

      if (total >= tier.amountCents) classes.push('is-reached');
      if (summary.currentTierIndex === index) classes.push('is-current');

      return [
        '<div class="' + classes.join(' ') + '">',
        '  <span class="arcos-gift-experience__marker-dot"></span>',
        '  <span class="arcos-gift-experience__marker-label">' + escapeHtml(formatMoney(tier.amountCents)) + '</span>',
        '</div>'
      ].join('');
    }).join('');

    return [
      '<div class="arcos-gift-experience__progress">',
      '  <div class="arcos-gift-experience__progress-head">',
      '    <span class="arcos-gift-experience__progress-label">Progreso de la promo</span>',
      '    <span class="arcos-gift-experience__progress-value">Llevas ' + escapeHtml(formatMoney(total)) + ' en productos sin descuento</span>',
      '  </div>',
      '  <div class="arcos-gift-experience__track"><div class="arcos-gift-experience__fill" style="width:' + width.toFixed(2) + '%"></div></div>',
      '  <div class="arcos-gift-experience__markers">' + markers + '</div>',
      '</div>'
    ].join('');
  }

  function getAllGiftProducts() {
    var allProducts = [];
    var seen = Object.create(null);

    runtime.config.tiers.forEach(function (tier) {
      var products = Array.isArray(tier.products) ? tier.products : [];

      products.forEach(function (product) {
        if (!product || !product.variantId) return;

        var key = String(product.variantId || product.productId || product.handle || '');
        if (!key || seen[key]) return;

        seen[key] = true;
        allProducts.push({
          productId: product.productId,
          handle: product.handle,
          title: product.title,
          url: product.url,
          image: product.image,
          variantId: product.variantId,
          available: product.available,
          unlockAmountCents: tier.amountCents || 0,
          unlockTierId: tier.id,
          unlockTierTitle: tier.title || ''
        });
      });
    });

    return allProducts;
  }

  function buildProductsMarkup(summary) {
    var products = getAllGiftProducts();

    if (!products.length) {
      return [
        '<div class="arcos-gift-experience__empty">',
        '  <p>' + escapeHtml(uiText('emptyStateText')) + '</p>',
        '  <a class="arcos-gift-experience__button" href="' + escapeHtml(runtime.config.giftPageUrl) + '">' + escapeHtml(uiText('viewGiftPage')) + '</a>',
        '</div>'
      ].join('');
    }

    return products.map(function (product) {
      var isUnlocked = summary.eligibleTotal >= product.unlockAmountCents;
      var isAvailable = !!product.available;
      var remaining = Math.max(product.unlockAmountCents - summary.eligibleTotal, 0);

      var cardClasses = ['arcos-gift-experience__product'];
      if (isUnlocked) cardClasses.push('is-unlocked');
      if (!isUnlocked) cardClasses.push('is-locked');
      if (!isAvailable) cardClasses.push('is-soldout');

      var badgeText = '';
      if (!isAvailable) {
        badgeText = uiText('badgeSoldOut');
      } else if (isUnlocked) {
        badgeText = uiText('badgeUnlocked');
      } else {
        badgeText = uiText('badgeRemaining', { amount: formatMoney(remaining) });
      }

      var metaText = uiText('metaUnlockWith', {
        amount: formatMoney(product.unlockAmountCents)
      });
      var lockText = isUnlocked
        ? uiText('lockTextUnlocked')
        : uiText('lockTextRemaining', { amount: formatMoney(remaining) });

      var imageStatusLabel = '';
      if (!isUnlocked && isAvailable) {
        imageStatusLabel = '<div class="arcos-gift-experience__product-image-status">' + escapeHtml(uiText('imageStatusAvailableFrom', { amount: formatMoney(product.unlockAmountCents) })) + '</div>';
      }

      var buttonLabel = !isAvailable
        ? uiText('buttonSoldOut')
        : (isUnlocked ? uiText('buttonChooseGift') : uiText('buttonLocked'));

      var disabledAttr = isUnlocked && isAvailable ? '' : ' disabled';

      return [
        '<article class="' + cardClasses.join(' ') + '">',
        '  <div class="arcos-gift-experience__product-image">',
        product.image
          ? '    <img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
          : '    <div></div>',
          imageStatusLabel,
        '  </div>',
        '  <div class="arcos-gift-experience__product-copy">',
        '    <div class="arcos-gift-experience__product-badge">' + escapeHtml(badgeText) + '</div>',
        '    <h3 class="arcos-gift-experience__product-title">' + escapeHtml(product.title) + '</h3>',
        '    <p class="arcos-gift-experience__product-meta">' + escapeHtml(metaText) + '</p>',
        '    <p class="arcos-gift-experience__product-locktext">' + escapeHtml(lockText) + '</p>',
        '  </div>',
        '  <button type="button" class="arcos-gift-experience__button arcos-gift-experience__product-action" data-arcos-gift-action="claim-product" data-variant-id="' + escapeHtml(product.variantId) + '" data-goal-id="' + escapeHtml(product.unlockTierId) + '"' + disabledAttr + '>' + escapeHtml(buttonLabel) + '</button>',
        '</article>'
      ].join('');
    }).join('');
  }

  function buildProductsCarousel(summary) {
    return [
      '<div class="arcos-gift-experience__carousel">',
      '  <button type="button" class="arcos-gift-experience__carousel-nav is-prev" data-arcos-gift-action="carousel-prev" aria-label="' + escapeHtml(uiText('carouselPrev')) + '">',
      '    <span aria-hidden="true">‹</span>',
      '  </button>',
      '  <div class="arcos-gift-experience__carousel-viewport" data-arcos-gift-carousel-viewport>',
      '    <div class="arcos-gift-experience__carousel-track">',
             buildProductsMarkup(summary),
      '    </div>',
      '  </div>',
      '  <button type="button" class="arcos-gift-experience__carousel-nav is-next" data-arcos-gift-action="carousel-next" aria-label="' + escapeHtml(uiText('carouselNext')) + '">',
      '    <span aria-hidden="true">›</span>',
      '  </button>',
      '</div>'
    ].join('');
  }

  function getCarouselViewport() {
    return body ? body.querySelector('[data-arcos-gift-carousel-viewport]') : null;
  }

  function getCarouselStep(viewport) {
    if (!viewport) return 320;

    var firstCard = viewport.querySelector('.arcos-gift-experience__product');
    var track = viewport.querySelector('.arcos-gift-experience__carousel-track');

    if (!firstCard || !track) {
      return Math.max(viewport.clientWidth * 0.85, 280);
    }

    var trackStyles = window.getComputedStyle(track);
    var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);

    return firstCard.getBoundingClientRect().width + gap;
  }

  function updateCarouselNavState() {
    var viewport = getCarouselViewport();
    if (!viewport) return;

    var prevButton = body.querySelector('[data-arcos-gift-action="carousel-prev"]');
    var nextButton = body.querySelector('[data-arcos-gift-action="carousel-next"]');

    if (!prevButton || !nextButton) return;

    var maxScrollLeft = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
    var currentScrollLeft = viewport.scrollLeft;

    prevButton.disabled = currentScrollLeft <= 4;
    nextButton.disabled = currentScrollLeft >= (maxScrollLeft - 4);
  }

  function bindCarouselViewport() {
    var viewport = getCarouselViewport();
    if (!viewport || viewport.dataset.arcosGiftCarouselBound === '1') return;

    viewport.dataset.arcosGiftCarouselBound = '1';
    viewport.addEventListener('scroll', updateCarouselNavState, { passive: true });

    window.setTimeout(function () {
      updateCarouselNavState();
    }, 30);
  }

  function moveCarousel(direction) {
    var viewport = getCarouselViewport();
    if (!viewport) return;

    viewport.scrollBy({
      left: getCarouselStep(viewport) * 2 * direction,
      behavior: 'smooth'
    });

    window.setTimeout(function () {
      updateCarouselNavState();
    }, 350);
  }

  function renderFirstUnlock(summary) {
    var firstTier = runtime.config.tiers[0];
    var currentTier = summary.currentTier || firstTier;
    var nextTier = summary.nextTier;
    var helperText = nextTier
      ? uiText('helperNextTier', {
          goal: '<strong>' + escapeHtml(formatMoney(nextTier.amountCents)) + '</strong>',
          remaining: '<strong>' + escapeHtml(formatMoney(Math.max(nextTier.amountCents - summary.eligibleTotal, 0))) + '</strong>'
        })
      : uiText('helperMaxReached');

    body.innerHTML = [
      '<div class="arcos-gift-experience__selection arcos-gift-experience__selection--full">',
      '  <div class="arcos-gift-experience__selection-head">',
      '    <div class="arcos-gift-experience__eyebrow">' + escapeHtml(uiText('eyebrowUnlocked')) + '</div>',
      '    <h2 id="ArcosGiftJourneyTitle" class="arcos-gift-experience__title">' + escapeHtml(uiText('titleFirstUnlock')) + '</h2>',
      '    <p class="arcos-gift-experience__text">' + uiText('textFirstUnlock', { amount: '<strong>' + escapeHtml(formatMoney(currentTier.amountCents)) + '</strong>' }) + '</p>',
      buildProgress(summary),
      '    <div class="arcos-gift-experience__helper">' + helperText + '</div>',
      '  </div>',
      '  <div class="arcos-gift-experience__products-carousel-wrap">' + buildProductsCarousel(summary) + '</div>',
      '  <div class="arcos-gift-experience__actions">',
      '    <button type="button" class="arcos-gift-experience__button arcos-gift-experience__button--secondary" data-arcos-gift-action="close">' + escapeHtml(uiText('buttonLater')) + '</button>',
      '    <a class="arcos-gift-experience__link" href="' + escapeHtml(runtime.config.giftPageUrl) + '" data-arcos-gift-action="go-page">' + escapeHtml(uiText('viewGiftPage')) + '</a>',
      '  </div>',
      '</div>'
    ].join('');

    bindCarouselViewport();
    updateCarouselNavState();
    openModal();
  }

  function renderConfirmation(summary) {
    var nextTier = summary.nextTier;
    var text = nextTier
      ? uiText('confirmationTextNextTier', { amount: formatMoney(nextTier.amountCents) })
      : uiText('confirmationTextMax');

    body.innerHTML = [
      '<div class="arcos-gift-experience__confirm">',
      '  <div class="arcos-gift-experience__eyebrow">' + escapeHtml(uiText('eyebrowAdded')) + '</div>',
      '  <h2 id="ArcosGiftJourneyTitle" class="arcos-gift-experience__title">' + escapeHtml(uiText('titleAdded')) + '</h2>',
      buildProgress(summary),
      '  <div class="arcos-gift-experience__confirm-box">',
      '    <p class="arcos-gift-experience__confirm-text">' + escapeHtml(text) + '</p>',
      '  </div>',
      '  <div class="arcos-gift-experience__actions">',
      '    <button type="button" class="arcos-gift-experience__button arcos-gift-experience__button--secondary" data-arcos-gift-action="close">' + escapeHtml(uiText('buttonClose')) + '</button>',
      '    <a class="arcos-gift-experience__link" href="' + escapeHtml(runtime.config.giftPageUrl) + '" data-arcos-gift-action="go-page">' + escapeHtml(uiText('buttonGoGiftPage')) + '</a>',
      '  </div>',
      '</div>'
    ].join('');

    openModal();
  }

  async function fetchCart() {
    var response = await fetch('/cart.js?_=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) throw new Error('No se pudo cargar /cart.js');
    return response.json();
  }

  async function removeExistingPromoGifts(items) {
    var promoLines = (items || []).filter(function (item) {
      return item &&
        item.properties &&
        item.properties._agp_promo_engine === runtime.config.promoEngine;
    });

    for (var i = 0; i < promoLines.length; i += 1) {
      var response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: promoLines[i].key,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error('No se pudo quitar el regalo anterior');
      }
    }
  }

  async function addGiftVariant(variantId, goalId) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              _agp_promo_engine: runtime.config.promoEngine,
              _agp_promo_role: 'gift',
              _agp_goal_id: goalId
            }
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error('No se pudo añadir el regalo');
    }

    return response.json();
  }

  async function claimGift(variantId, goalId) {
    if (runtime.busy) return;
    runtime.busy = true;

    try {
      var parsedVariantId = parseInt(variantId, 10);

      if (!parsedVariantId) {
        throw new Error('Variant ID inválido');
      }

      var cart = await fetchCart();
      var preSummary = getCartSummary(cart);

      if (preSummary.currentTierIndex < 0) {
        throw new Error('Aún no hay ninguna meta desbloqueada');
      }

      await removeExistingPromoGifts(cart.items || []);
      await addGiftVariant(parsedVariantId, goalId);

      var optimisticSummary = {
        eligibleTotal: preSummary.eligibleTotal,
        currentTierIndex: preSummary.currentTierIndex,
        currentTier: preSummary.currentTier,
        nextTier: preSummary.nextTier,
        hasGift: true,
        giftSignature: 'optimistic:' + parsedVariantId + ':' + goalId
      };

      sessionStorage.setItem(CONFIRMED_GIFT_SIG_KEY, optimisticSummary.giftSignature);

      renderConfirmation(optimisticSummary);

      runtime.busy = false;

      setTimeout(function () {
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (refreshError) {
          console.warn('[Arcos Gift Experience] cart:refresh error', refreshError);
        }
      }, 300);

      return;
    } catch (error) {
      console.error('[Arcos Gift Experience]', error);

      body.innerHTML = [
        '<div class="arcos-gift-experience__confirm">',
        '  <div class="arcos-gift-experience__eyebrow">' + escapeHtml(uiText('errorEyebrow')) + '</div>',
        '  <h2 id="ArcosGiftJourneyTitle" class="arcos-gift-experience__title">' + escapeHtml(uiText('errorTitle')) + '</h2>',
        '  <div class="arcos-gift-experience__confirm-box">',
        '    <p class="arcos-gift-experience__confirm-text">' + escapeHtml(uiText('errorText')) + '</p>',
        '  </div>',
        '  <div class="arcos-gift-experience__actions">',
        '    <button type="button" class="arcos-gift-experience__button arcos-gift-experience__button--secondary" data-arcos-gift-action="close">' + escapeHtml(uiText('buttonClose')) + '</button>',
        '    <a class="arcos-gift-experience__button" href="' + escapeHtml(runtime.config.giftPageUrl) + '" data-arcos-gift-action="go-page">' + escapeHtml(uiText('buttonGoGiftPage')) + '</a>',
        '  </div>',
        '</div>'
      ].join('');

      openModal();
      runtime.busy = false;
    }
  }

  async function evaluateGiftFlow() {
    if (!isCampaignActive()) return;

    try {
      var cart = await fetchCart();
      var summary = getCartSummary(cart);
      var prevEligibleRaw = sessionStorage.getItem(PREV_ELIGIBLE_KEY);
      var prevEligible = prevEligibleRaw == null ? NaN : parseInt(prevEligibleRaw, 10);

      if (!runtime.initialisedCartSnapshot) {
        runtime.lastGiftSignature = summary.giftSignature || '';
        sessionStorage.setItem(LAST_VIEWED_GIFT_SIG_KEY, runtime.lastGiftSignature);
        runtime.initialisedCartSnapshot = true;
      }

      if (summary.eligibleTotal < runtime.config.tiers[0].amountCents) {
        sessionStorage.removeItem(SHOWN_FIRST_KEY);
      }

      var crossedTierIndex = null;

      if (!Number.isNaN(prevEligible)) {
        runtime.config.tiers.forEach(function (tier, index) {
          if (prevEligible < tier.amountCents && summary.eligibleTotal >= tier.amountCents) {
            crossedTierIndex = index;
          }
        });
      } else if (summary.eligibleTotal >= runtime.config.tiers[0].amountCents) {
        crossedTierIndex = 0;
      }

      if (isGiftPage()) {
        if (crossedTierIndex != null && !summary.hasGift) {
          sessionStorage.setItem(SHOWN_FIRST_KEY, '1');
        }

        runtime.lastGiftSignature = summary.giftSignature || '';
        sessionStorage.setItem(LAST_VIEWED_GIFT_SIG_KEY, runtime.lastGiftSignature);
        sessionStorage.setItem(PREV_ELIGIBLE_KEY, String(summary.eligibleTotal));
        return;
      }

      if (
        crossedTierIndex != null &&
        !summary.hasGift &&
        sessionStorage.getItem(SHOWN_FIRST_KEY) !== '1'
      ) {
        try {
          await ensureCatalogLoaded();
        } catch (catalogError) {
          console.warn('[Arcos Gift Experience] No se pudo completar la carga de todos los regalos', catalogError);
        }

        renderFirstUnlock(summary);
        sessionStorage.setItem(SHOWN_FIRST_KEY, '1');
      }

      runtime.lastGiftSignature = summary.giftSignature || '';
      sessionStorage.setItem(LAST_VIEWED_GIFT_SIG_KEY, runtime.lastGiftSignature);
      sessionStorage.setItem(PREV_ELIGIBLE_KEY, String(summary.eligibleTotal));
    } catch (error) {
      console.warn('[Arcos Gift Experience] No se pudo evaluar el flujo', error);
    }
  }

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
      return;
    }

    var actionTarget = event.target.closest('[data-arcos-gift-action]');
    if (!actionTarget) return;

    var action = actionTarget.getAttribute('data-arcos-gift-action');

    if (action === 'close') {
      closeModal();
      return;
    }

    if (action === 'carousel-prev') {
      moveCarousel(-1);
      return;
    }

    if (action === 'carousel-next') {
      moveCarousel(1);
      return;
    }

    if (action === 'claim-product') {
      claimGift(actionTarget.getAttribute('data-variant-id'), actionTarget.getAttribute('data-goal-id'));
      return;
    }

    if (action === 'go-page') {
      closeModal();
      window.location.href = runtime.config.giftPageUrl;
    }
  });

  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  document.addEventListener('line-item:change:end', function () {
    queueEvaluateGiftFlow(400);
  });

  document.addEventListener('cart:item-added', function () {
    queueEvaluateGiftFlow(500);
  });

  document.addEventListener('cart:refresh', function () {
    queueEvaluateGiftFlow(400);
  });

  document.addEventListener('cart-drawer:open', function () {
    queueEvaluateGiftFlow(500);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      queueEvaluateGiftFlow(250);
    }
  });

  window.addEventListener('focus', function () {
    queueEvaluateGiftFlow(250);
  });

  window.addEventListener('pageshow', function () {
    queueEvaluateGiftFlow(350);
  });

  window.addEventListener('resize', function () {
    updateCarouselNavState();
  });

  window.addEventListener('load', function () {
    queueEvaluateGiftFlow(750);
  });

  window.setInterval(function () {
    if (document.visibilityState === 'visible' && isCampaignActive() && modal.hidden) {
      queueEvaluateGiftFlow(0);
    }
  }, 1800);
});